"use client";

import { useState, useEffect } from "react";
import Image from "next/image";

const SLIDES = [
  { src: "/images/pages/migrated/446cc773082872d70caf6119364ae45f6c60582f-5760x3520.webp", width: 3840, height: 2347 },
  { src: "/images/pages/migrated/f902e4f4aa5aa8b10cca677633cb28d9a7760036-5760x3520.webp", width: 3840, height: 2347 },
  { src: "/images/pages/migrated/504ea811dfdbbb0f3c7626aa9ec56cb9de94a813-5760x3520.webp", width: 3840, height: 2347 },
];

// The slider is capped at max-w-6xl (72rem), so next/image never needs the 5760px originals.
const SIZES = "(min-width: 72rem) 72rem, 100vw";

export default function HeroCDNSlider() {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const id = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % SLIDES.length);
    }, 6000);
    return () => clearInterval(id);
  }, []);

  return (
    <div className="relative w-full max-w-6xl rounded-lg overflow-hidden z-10">
      <Image
        src={SLIDES[0].src}
        width={SLIDES[0].width}
        height={SLIDES[0].height}
        alt=""
        aria-hidden
        sizes={SIZES}
        className="w-full h-auto invisible"
        style={{ height: "auto" }}
        priority
      />
      {SLIDES.map((slide, index) => (
        <div
          key={index}
          className="absolute inset-0"
          style={{
            opacity: index === currentIndex ? 1 : 0,
            transition: "opacity 600ms ease-in-out",
          }}
        >
          <Image
            src={slide.src}
            width={slide.width}
            height={slide.height}
            alt="Agent0 overview"
            sizes={SIZES}
            className="w-full h-full object-cover rounded-lg"
            priority={index === 0}
          />
        </div>
      ))}
    </div>
  );
}
